import { createSelector } from 'reselect'
import { HomeState } from 'src/modules/home/home_slice'
import { VideoObject } from 'src/modules/shared/Types'
import { RootState } from 'src/modules/store'

const selectRaw = (state: RootState): HomeState => state.home
const selectFetchVideosLoading = (categoryName: string) => {
  return createSelector([selectRaw], (raw) => raw.fetchVideosLoading.includes(categoryName))
}
const selectOnDemandVideos = (categoryName: string) => {
  return createSelector([selectRaw], (raw:HomeState):Array<VideoObject> => raw.onDemandVideos[`${categoryName}`])
}

const selectAllVideos = createSelector([selectRaw], (raw:HomeState) => {
  return Object.values(raw.onDemandVideos) as Array<Array<VideoObject>>
})

const selectDefaultVideoUrl = createSelector([selectRaw], (raw: HomeState) => {
  return raw.defaultVideoUrl
})

const homeSelectors = {
  selectRaw,
  selectFetchVideosLoading,
  selectAllVideos,
  selectDefaultVideoUrl,
  selectOnDemandVideos,
}

export default homeSelectors
